export const processSteps = [
    { step: 1, title: "견적 및 수주" },
    { step: 2, title: "구매 및 발주" },
    { step: 3, title: "출고" },
];
export const projectSearchHeaders = [
    { text: "프로젝트 이름", align: "start", value: "name" },
    { text: "프로젝트 코드", align: "start", value: "projectCode" },
    { text: "업체명", align: "start", value: "companyName" },
    { text: "상태", align: "center", value: "status" },
    { text: "시작일", align: "start", value: "createdTime" },
];
export const PROJECT_STATUS_COLOR = {
    진행중: "blue",
    중단: "red",
    완료: "green",
};
export const tabItems = ["활동 로그", "문서 관리", "댓글"];
export const mockProcess = {
    id: 101,
    projectCode: "P-2026-0001",
    estimate: {
        isCompleted: true,
        items: [
            {
                id: 1001,
                createrName: "관리자",
                approvalPhase: "승인",
                createdTime: "2026-01-10T09:15:00Z",
                isHistory: 0,
                originId: 1001,
                version: 1,
                checkerName: null,
                approverName: null,
                companyName: null,
                inhouseBidNumber: null,
                companyBidNumber: null,
                totalPrice: null,
            },
        ],
    },
    obtain: {
        isCompleted: false,
        items: [
            {
                id: 2001,
                createrName: "영업담당자",
                approvalPhase: "미승인",
                createdTime: "2026-01-12T10:00:00Z",
                isHistory: 0,
                originId: 2001,
                version: 1,
                checkerName: null,
                approverName: null,
                companyName: null,
                inhouseBidNumber: null,
                companyBidNumber: null,
                totalPrice: null,
            },
        ],
    },
    purchase: {
        isCompleted: false,
        items: [
            {
                id: 3001,
                createrName: "구매담당자",
                approvalPhase: "승인",
                createdTime: "2026-01-13T08:45:00Z",
                isHistory: 0,
                originId: 3001,
            },
            {
                id: 3002,
                createrName: "구매담당자2",
                approvalPhase: "미승인",
                createdTime: "2026-01-14T11:20:00Z",
                isHistory: 0,
                originId: 3002,
            },
        ],
    },
    order: {
        isCompleted: false,
        items: [
            {
                id: 4001,
                createrName: "수주담당자",
                approvalPhase: "발주완료",
                createdTime: "2026-01-15T09:00:00Z",
                isHistory: 0,
                originId: 4001,
            },
            {
                id: 4002,
                createrName: "수주담당자",
                approvalPhase: "진행중",
                createdTime: "2026-01-15T09:00:00Z",
                isHistory: 0,
                originId: 4002,
            },
        ],
    },
    inbound: {
        isCompleted: false,
        items: [
            {
                id: 5001,
                createrName: "입고담당자",
                approvalPhase: "승인",
                createdTime: "2026-01-16T13:00:00Z",
                isHistory: 0,
                originId: 5001,
            },
        ],
    },
    outbound: {
        isCompleted: false,
        items: [
            {
                id: 6001,
                createrName: "출고담당자",
                approvalPhase: "미승인",
                createdTime: "2026-01-17T15:20:00Z",
                isHistory: 0,
                originId: 6001,
            },
        ],
    },
};
